import React, { forwardRef } from "react";
import PropTypes from "prop-types";

const PrintContent = forwardRef(({ data, deliveryObj }, ref) => {
  const numberOfItems = data.length;

  const TermsAndConditions = {
    Note: "Note: No guarantee for stone, fancy, kids items and No Exchange.",
    Description:
      "Composition taxable person not eligible to collect tax on supplies.",
  };

  return (
    <div
      ref={ref}
      style={{
        border: "2px solid #000",
        padding: "20px",
        width: "90%",
        margin: "0 auto",
        boxSizing: "border-box",
      }}
    >
      <div id="page-wrap" style={{ width: "100%" }}>
        <table
          width="100%"
          style={{
            borderCollapse: "collapse",
            width: "100%",
            marginBottom: "20px",
          }}
          cellSpacing="0"
          cellPadding="0"
        >
          <tbody>
            <tr>
              <td style={{ height: "30px" }} valign="top">
                <h2
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    marginTop: "3px",
                    marginBottom: "3px",
                    fontSize: "18px",
                  }}
                >
                  Delivery Challan
                </h2>
              </td>
            </tr>
          </tbody>
        </table>

        <div style={{ width: "49%", paddingRight: "10px" }}>
          <ul
            style={{
              listStyleType: "none",
              padding: 0,
              margin: 0, // Ensure there's no default margin
              display: "flex",
              flexDirection: "column",
              gap: "8px", // Add space between list items
            }}
          >
            <li
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: "bold",
              }}
            >
              Challan Details:
            </li>
            <li
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span>Challan Number:</span>
              <span>{deliveryObj?.OrderNo}</span>
            </li>
            <li
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span>Date:</span>
              <span>
                {new Date(deliveryObj?.Orderdate).toLocaleDateString("en-GB")}
              </span>
            </li>
            <li
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span>Delivery Person:</span>
              <span>{deliveryObj?.TransportMode}</span>
            </li>
            <li
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span>Delivery Vehicle No:</span>
              <span>{deliveryObj?.TransportvehicleNumber}</span>
            </li>
          </ul>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <h4>Products</h4>
          <table
            style={{
              width: "100%",
              border: "1px solid #000",
              borderCollapse: "collapse",
              marginBottom: "20px",
            }}
          >
            <thead>
              <tr>
                <th style={{ border: "1px solid #000", padding: "8px" }}>
                  S.No
                </th>
                <th style={{ border: "1px solid #000", padding: "8px" }}>
                  Item
                </th>
                <th style={{ border: "1px solid #000", padding: "8px" }}>
                  Quantity
                </th>
                <th style={{ border: "1px solid #000", padding: "8px" }}>
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data?.map((item, index) => (
                  <tr key={index}>
                    <td
                      style={{
                        border: "1px solid black",
                        textAlign: "center",
                        padding: "8px",
                      }}
                    >
                      {index + 1}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        textAlign: "center",
                        padding: "8px",
                      }}
                    >
                      {item.ProductName}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        textAlign: "center",
                        padding: "8px",
                      }}
                    >
                      {item.Quantity}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        textAlign: "center",
                        padding: "8px",
                      }}
                    >
                      {item.UnitPrice * item.Quantity}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="6"
                    style={{ textAlign: "center", padding: "8px" }}
                  >
                    No Products Available
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <td
                  colSpan="3"
                  style={{
                    border: "1px solid black",
                    textAlign: "right",
                    padding: "8px",
                  }}
                >
                  Total:
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    padding: "8px",
                  }}
                >
                  {deliveryObj ? deliveryObj.Total : "N/A"}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div
          style={{
            marginBottom: "20px",
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <h3>No Of Items: {numberOfItems ? numberOfItems : "N/A"}</h3>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <h6>Terms & Conditions:</h6>
          <p>{TermsAndConditions.Note}</p>
          <p>{TermsAndConditions.Description}</p>
        </div>
      </div>
    </div>
  );
});

PrintContent.displayName = "PrintContent";

PrintContent.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      ProductName: PropTypes.string.isRequired,
      Quantity: PropTypes.number.isRequired,
      Total: PropTypes.number.isRequired,
    })
  ).isRequired,
  deliveryObj: PropTypes.shape({
    OrderNo: PropTypes.string.isRequired,
    Orderdate: PropTypes.string.isRequired,
    TransportvehicleNumber: PropTypes.string.isRequired,
    TransportMode: PropTypes.string.isRequired,
    Total: PropTypes.number.isRequired,
  }).isRequired,
};

export default PrintContent;
